module.exports = __webpack_public_path__ + "img/delete-item.3adb0efa.svg";